class QuizValidation {
    constructor (quiz, $t) {
        this.quiz = quiz
        this.$t = $t
    }

    validation () {
        const quiz = this.quiz
        const questions = quiz.questions
        const regex = /^[A-Za-z0-9\-\_\,\&\+\=\[\]\'\"\:\|\\\/\#\$\%\*\~\;\<\>\{\}\`@!?(). ]*$/

        // for status
        let status = []
        let notEnglishQuestions = []
        let maxWarnCharacter = 150;
        let overMaxWarnQuestions = []
        let isEnglishValidation = {
            status: true,
            message: this.$t('submit_approval_modal_validate_must_english')
        };
        let isQuestionValidation = {
            status: true,
            message: this.$t('submit_approval_modal_validate_question_max')
        }
        let isChoicesValidation = {
            status: true,
            message: this.$t('submit_approval_modal_validate_choice_max')
        }
        let isMoreThanEqual10QuestionsValidation = {
            status: true,
            message: this.$t('submit_approval_modal_validate_quiz_max')
        }
        let isDiffTypesOfQuestionsValidation = {
            status: true,
            message: this.$t('submit_approval_modal_validate_types_question')
        }
        let isDiffTypesOfChoicesValidation = {
            status: true,
            message: this.$t('submit_approval_modal_validate_types_choice')
        }
        let isFixedText = [
            {
                status: true,
                message: this.$t('submit_approval_modal_validate_self_explaining')
            },
            {
                status: true,
                message: this.$t('submit_approval_modal_validate_create')
            }
        ]
        let isTagSelected = {
            status: true,
            message: this.$t('submit_approval_modal_validate_category_tag')
        }


        // for validation
        let isNotEng = 0
        let isNotQuestionTitle = 0
        let isNotChoiceTitle = 0
        let isNotLeast10Questions = 0
        let isNotDiffTypesOfQuestions = 0
        let isNotDiffTypesOfChoice = 0

        let hasBasicType = false
        let hasOtherType = false

        return new Promise((resolve, reject) => {
            if (quiz) {
                if (
                    !regex.test(quiz.title) ||
                    quiz.description && !regex.test(quiz.description) ||
                    quiz.custom_message && !regex.test(quiz.custom_message)) {
                    isNotEng++
                }

                if (questions.length > 0) {
                    if (questions.length < 10) {
                        isNotLeast10Questions++
                    }

                    questions.forEach((question, index) => {
                        if (question.title.length > 0 && !regex.test(question.title)) {
                            isNotEng++
                            notEnglishQuestions.push(index + 1)
                        }

                        if (question.title.length > maxWarnCharacter) {
                            isNotQuestionTitle++
                            overMaxWarnQuestions.push(index + 1)
                        }

                        if ((question.question_type &&
                            question.question_type != 'typing_question' &&
                            question.question_type != 'puzzle' &&
                            question.question_type != 'hotspot' &&
                            question.question_type != 'scramble') &&
                            (question.answers.length < 2 || question.answers.length > 8)) {
                            isNotDiffTypesOfChoice++
                        }

                        if (question.question_type) {
                            if (question.question_type === 'basic') {
                                hasBasicType = true
                            } else {
                                hasOtherType = true
                            }
                        }


                        question.answers.forEach(answer => {
                            if (answer.title.length > 0 && !regex.test(answer.title)) {
                                isNotEng++
                                notEnglishQuestions.push(index + 1)
                            }
                            if (answer.title.length > 100) {
                                isNotChoiceTitle++
                            }
                        })
                    })



                    notEnglishQuestions = notEnglishQuestions.filter((val, index, self) => {
                        return self.indexOf(val) == index
                    })

                    if (overMaxWarnQuestions.length) {
                        let warnMsg = `Some questions (${overMaxWarnQuestions.join(', ')}) `

                        if (overMaxWarnQuestions.length == questions.length) {
                            warnMsg = 'All question '
                        }

                        warnMsg += `has more than ${maxWarnCharacter} characters. We recommend keeping the questions within this amount. \n`
                        warnMsg += "You can proceed with longer questions, but they may not be approved if they are not written effectively and correctly."

                        isQuestionValidation.message = warnMsg
                        isQuestionValidation.textColor = 'text-orange'
                    }

                    if (notEnglishQuestions.length) {
                        notEnglishQuestions = notEnglishQuestions.join(', ')
                        isEnglishValidation.message = `${isEnglishValidation.message} (Question ${notEnglishQuestions})`
                    }

                    status = [
                        ...isFixedText,
                        { ...isTagSelected, status: quiz.tags.length > 0},
                        // { ...isEnglishValidation, status: isNotEng === 0 },
                        { ...isQuestionValidation, status: isNotQuestionTitle === 0 },
                        { ...isChoicesValidation, status: isNotChoiceTitle === 0 },
                        { ...isMoreThanEqual10QuestionsValidation, status: isNotLeast10Questions === 0 },
                        { ...isDiffTypesOfChoicesValidation, status: isNotDiffTypesOfChoice === 0 },
                        { ...isDiffTypesOfQuestionsValidation, status: questions.length > 1 && hasBasicType && hasOtherType }
                    ]

                    resolve(status)
                } else {
                    status = status.map(item => {
                        return {
                            ...item,
                            status: false
                        }
                    })

                    resolve(status)
                }
            } else {
                reject('No quiz data.')
            }
        })
    }
}

export default QuizValidation
